import * as NameSpace from 'src/store/NameSpace'

const state = {
  [NameSpace.SELECTED_DEPARTMENT]: {
    department: null
  },
  [NameSpace.SELECTED_SUB_DEPARTMENT]: {
    sub_department: null
  },
  [NameSpace.SELECTED_CLASS]: {
    class: null
  },
  [NameSpace.SELECTED_SUB_CLASS]: {
    sub_class: null
  }
}

const getters = {
  [NameSpace.GET_SELECTED_DEPARTMENT]: state => {
    return state[NameSpace.SELECTED_DEPARTMENT]
  },
  [NameSpace.GET_SELECTED_SUB_DEPARTMENT]: state => {
    return state[NameSpace.SELECTED_SUB_DEPARTMENT]
  },
  [NameSpace.GET_SELECTED_CLASS]: state => {
    return state[NameSpace.SELECTED_CLASS]
  },
  [NameSpace.GET_SELECTED_SUB_CLASS]: state => {
    return state[NameSpace.SELECTED_SUB_CLASS]
  }
}

const mutations = {
  [NameSpace.MUTATE_SELECTED_DEPARTMENT]: (state, payload) => {
    state[NameSpace.SELECTED_DEPARTMENT] = payload
  },
  [NameSpace.MUTATE_SELECTED_SUB_DEPARTMENT]: (state, payload) => {
    state[NameSpace.SELECTED_SUB_DEPARTMENT] = payload
  },
  [NameSpace.MUTATE_SELECTED_CLASS]: (state, payload) => {
    state[NameSpace.SELECTED_CLASS] = payload
  },
  [NameSpace.MUTATE_SELECTED_SUB_CLASS]: (state, payload) => {
    state[NameSpace.SELECTED_SUB_CLASS] = payload
  }
}

const actions = {
  [NameSpace.SET_SELECTED_DEPARTMENT]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_DEPARTMENT, { department: payload })
  },
  [NameSpace.SET_SELECTED_SUB_DEPARTMENT]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_SUB_DEPARTMENT, { sub_department: payload })
  },
  [NameSpace.SET_SELECTED_CLASS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_CLASS, { class: payload })
  },
  [NameSpace.SET_SELECTED_SUB_CLASS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_SUB_CLASS, { sub_class: payload })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dropdown.js